// extracted by mini-css-extract-plugin
module.exports = {"content":"RichTextContent_content__14juY","plain":"RichTextContent_plain__1Cr7G"};